import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useContext } from "react";
import { CompanyTypes, KindOfOrder } from "../../../../types/enums";
import { showErrorMessage } from "../../../../utils/messages";
import { useMarkStoreNoteAsRead } from "../../notes/api/mark-store-note-as-read";
import NoteGrid from "../../../common/notes/components/NoteGrid";
import { EstimateContext, RefetchScope } from "../context/EstimateContext";
import EstimateAddNoteButton from "./EstimateAddNoteButton";

export default function EstimateNotesGrid() {

	const { order, refetchOrder } = useContext(EstimateContext);
	const markNoteAsRead = useMarkStoreNoteAsRead(
		() => { refetchOrder(RefetchScope.Notes) },
		(error) => showErrorMessage(error));

	return (
		<>
			<Toolbar className='button-toolbar'>
				<Item location={'before'}>
					<EstimateAddNoteButton />
				</Item>
				<Item location={'after'}>
					{
						order.details.notes.find(x => x.createdByCompanyTypeID === CompanyTypes.DEALER && !x.readOn) &&
						<Button
							text="Mark All As Read"
							icon="Inscyth-Order-Material"
							disabled={markNoteAsRead.isLoading}
							onClick={() => {
								markNoteAsRead.mutate({ orderID: order.details.quoteID, kindOfOrder: KindOfOrder.Estimate });
							}}>
						</Button>
					}
				</Item>
			</Toolbar>
			<NoteGrid
				notes={order.details.notes}
				showMarkAsReadCompanyTypeID={CompanyTypes.DEALER}
				onMarkNoteAsRead={(noteID: number) => {
					markNoteAsRead.mutate({ noteID: noteID });
				}}
			/>
		</>
	)
}
